<template>
  <v-container fluid class="pa-0 ma-0">
    <v-row style="height: 100vh; width: 100%; margin: 0;">
      <v-col
        cols="12"
        sm="6"
        md="6"
        lg="6"
        v-if="!isMobile"
        style="padding: 0"
        class="bg-image-container"
      >
        <v-img :src="images.BG" cover class="full-height-image" />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="6"
        lg="6"
        class="login-scroll-container"
        style="padding: 0; height: 100vh; overflow-y: auto"
      >
        <div
          v-if="!hasCredential && switchToLogin"
          class="login-form-container"
        >
          <v-row
            align="center"
            justify="center"
            class="img-intersection2"
            style="margin: 0; height: auto"
          >
            <v-col cols="12" sm="8" md="8">
              <v-skeleton-loader
                :loading="!flagNav"
                transition="scale-transition"
                max-height="200"
                type="image"
                style="
                  justify-content: center;
                  align-items: center;
                  display: flex;
                "
              >
                <v-img
                  alt="Fusion Logo"
                  class="app img"
                  :src="images.logo"
                  transition="scale-transition"
                  contain
                  aspect-ratio="2"
                />
              </v-skeleton-loader>
              <v-alert type="error" v-model="erroralert">{{
                errorMessage
              }}</v-alert>
              <v-alert type="info" v-model="successalert">{{
                successMessage
              }}</v-alert>

              <div v-if="forgotpassword">
                <v-form class="form ml-3 mr-3">
                  <div class="form-group">
                    <label>Email Or Username</label>
                    <v-text-field
                      variant="outlined"
                      type="text"
                      v-model="Email"
                      hide-details="true"
                      placeholder="Enter your Email Or Username"
                      @keyup.enter="forgot"
                    />
                  </div>
                </v-form>
                <v-layout class="d-flex align-center justify-center mb-5">
                  <v-btn
                    v-show="forgotpassword"
                    class="login mt-4"
                    large
                    align="center"
                    justify="center"
                    @click="forgot"
                    :loading="loading"
                    >Send
                  </v-btn>
                  <v-btn
                    v-show="forgotpassword"
                    class="login mt-4 ml-2"
                    large
                    align="center"
                    justify="center"
                    v-on:click="forgotpassword = !forgotpassword"
                    >Cancel
                  </v-btn>
                </v-layout>
              </div>

              <div v-if="!forgotpassword">
                <v-form class="form ml-3 mr-3">
                  <div v-if="ProductAdminFlag" class="form-group">
                    <label>{{ $t("_CompanyCode") }}</label>
                    <v-text-field
                      variant="outlined"
                      type="text"
                      v-model="input.companyCode"
                      @input="companyCodeChecker = false"
                      @keyup.enter="login"
                      hide-details="true"
                      placeholder="Enter your company code"
                      :error="companyCodeChecker"
                      :maxlength="10"
                    />
                  </div>
                  <div v-if="ProductAdminFlag" class="d-flex align-center">
                    <v-divider horizontal class="mx-2"></v-divider>
                    <span
                      style="
                        color: grey;
                        font-size: smaller;
                        width: -webkit-fill-available;
                        text-align: center;
                      "
                    >
                      Login with username
                    </span>
                    <v-divider horizontal class="mx-2"></v-divider>
                  </div>
                  <div class="form-group">
                    <label>{{ $t("username") }}</label>
                    <v-text-field
                      variant="outlined"
                      name="login"
                      type="text"
                      @keyup.enter="login"
                      v-model="input.username"
                      hide-details="true"
                      placeholder="Enter your username"
                    />
                  </div>
                  <div class="form-group">
                    <label>{{ $t("password") }}</label>
                    <v-text-field
                      variant="outlined"
                      @keyup.enter="login"
                      v-model="input.password"
                      hide-details="true"
                      placeholder="Enter your password"
                      :type="show1 ? 'text' : 'password'"
                    >
                      <template v-slot:append-inner>
                        <v-icon @click="show1 = !show1">
                          {{ show1 ? "mdi-eye" : "mdi-eye-off" }}
                        </v-icon>
                      </template>
                    </v-text-field>
                  </div>
                  <v-row class="d-flex align-center justify-center">
                    <v-checkbox
                      :label="$t('rememberme')"
                      required
                      v-model="rememberMe"
                    ></v-checkbox>
                    <v-spacer />
                    <v-btn
                      v-show="!forgotpassword"
                      class="login mt-4"
                      large
                      align="center"
                      justify="center"
                      @click="login"
                      :loading="loading"
                      >{{ $t("login") }}</v-btn
                    >
                  </v-row>
                </v-form>
              </div>

              <v-layout
                class="d-flex align-center justify-center"
                v-show="!forgotpassword"
                style="margin-bottom: 1rem"
              >
                <a
                  v-on:click="forgotpassword = !forgotpassword"
                  class="forgotPassword"
                  >{{ $t("forgotpassword") }}</a
                >
              </v-layout>

              <div v-if="SSOMicrosoftFlag == true" class="d-flex align-center">
                <v-divider horizontal class="mx-2"></v-divider>
                <span
                  style="
                    color: grey;
                    font-size: smaller;
                    width: -webkit-fill-available;
                    text-align: center;
                  "
                  >Sign in with</span
                >
                <v-divider horizontal class="mx-2"></v-divider>
              </div>
              <div
                class="d-flex align-center justify-center"
                v-if="SSOMicrosoftFlag"
                style="margin-top: 2rem"
              >
                <v-btn
                  size="large"
                  @click="loginMicrosoft"
                  style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100%;"
                >
                  <v-icon size="30" style="padding-right: 5px"
                    >mdi-microsoft</v-icon
                  >
                  {{ $t("loginMicrosoft") }}
                </v-btn>
              </div>

              <div
                class="d-flex align-center justify-center"
                v-if="SSOAuthentikFlag"
                style="margin-top: 2rem"
              >
                <v-btn
                  size="large"
                  align="center"
                  justify="center"
                  @click="loginAuthentik"
                  style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100%;"
                >
                  <img width="30" src="@/assets/authentik_icon.svg" />&nbsp;
                  {{ $t("loginAuthentik") }}
                </v-btn>
              </div>

              <!-- <v-layout v-show="SSOAuthentikFlag" flex align-center justify-center style="margin-top: 2rem">
                <v-btn class="loginMicrosoft " large align="center" justify="center" @click="loginLine">
                  <img width="30" src="@/assets/logo-line.svg" />&nbsp;
                  {{ $t('loginLine') }}
                </v-btn>
              </v-layout> -->
            </v-col>
          </v-row>
        </div>

        <div
          v-else
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100vh;
          "
        >
          <v-card
            style="
              border: 0px;
              border-radius: 15px;
              height: 450px;
              width: 500px;
              box-shadow: 6px 8px 15px rgba(0, 0, 0, 0.15);
            "
          >
            <v-card-title class="d-flex align-center justify-center">
              <div class="login-container">
                <div class="user-image" style="margin: 0px 0 25px 0">
                  <img :src="images.user" alt="User Profile Image" />
                </div>
                <h2 style="margin-bottom: 5px">{{ fullname }}</h2>
                <p style="font-size: smaller; margin-bottom: 25px; color: grey">
                  {{ companyName }}
                </p>
                <v-alert
                  v-if="errorRememberAlert"
                  type="error"
                  height="50"
                  class="d-flex align-center justify-center"
                  >The User was not found.</v-alert
                >
                <v-btn
                  @click="login"
                  :loading="loading"
                  class="login"
                  style="height: 50px"
                  >{{ $t("login") }}</v-btn
                >
                <p class="changeAccount">
                  <span
                    style="text-decoration: underline; cursor: pointer"
                    @click="SwitchToLogin"
                  >
                    Change account</span
                  >
                </p>
              </div>
            </v-card-title>
          </v-card>
        </div>
      </v-col>
    </v-row>
    <v-overlay :value="dialog">
      <v-dialog v-model="dialog" persistent width="300">
        <v-card color="#1976D2" dark>
          <v-card-text class="white--text">
            Loading Please Wait...
            <v-progress-linear
              indeterminate
              color="#FAA91B"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>
  </v-container>
</template>
<script>
import LogTrace from "@/api/function.js";
import { isMenuClosed, getLandingRoute } from "@/config/menuClosure";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import logoImg from "@/assets/images/chatframework 1.png";
import bgImg from "@/assets/images/bg-ai.png";
import userImg from "@/assets/images/user.png";
import { useDisplay } from "vuetify";

export default {
  mixins: [LogTrace],
  name: "Login",
  inject: ["flagNav", "LoginLogo", "colorThemeChat"],
  setup() {
    const display = useDisplay();
    return { display };
  },
  data() {
    return {
      companyCodeChecker: false,
      expiryDate: "",
      switchToLogin: true,
      rememberMe: false,
      dialog: false,
      loading: false,
      forgotpassword: false,
      erroralert: false,
      errorRememberAlert: false,
      successalert: false,
      successMessage: "",
      errorMessage: "",
      show1: false,
      remember: "",
      companyName: "",
      fullname: "",
      secretKey: "SecretPassphrase@2020",
      permissionID: [],
      hasCredential: false,
      input: {
        companyCode: "",
        username: "",
        password: "",
      },
      authenticated: Cookies.get("authenticated"),
      rememberMetext: Cookies.get("rememberMe"),
      Email: "",
      images: {
        logo: logoImg,
        BG: bgImg,
        user: userImg,
      },
      SSOMicrosoftFlag: false,
      SSOAuthentikFlag: false,
      ProductAdminFlag: false,
    };
  },
  async created() {
    this.ProductAdminFlag = import.meta.env.VITE_APP_ProductAdmin === "true";
  },
  mounted: function () {
    if (this.LoginLogo != null && this.LoginLogo != undefined) {
      this.images.logo = this.LoginLogo;
    }
    if (this.authenticated) {
      // Custom Page Permission: redirect to first allowed page — supports new {key,mode} and legacy string list.
      const roleId = Cookies.get("roleId");
      if (Cookies.get("isCustomPageAccess") === "true") {
        try {
          const raw = JSON.parse(localStorage.getItem("customPagePermission") || "[]");
          const allowedKeys = Array.isArray(raw)
            ? raw.map((e) => (typeof e === "string" ? e : e && e.key)).filter(Boolean)
            : [];
          // ข้ามหน้าที่ถูกปิดตาม menuClosure config ไม่งั้นจะถูกส่งไป AccessDenied ทันทีหลังเข้าสู่ระบบ
          const firstKey = allowedKeys.find((key) => !isMenuClosed(key));
          if (firstKey) {
            this.$router.push({ name: firstKey });
          } else {
            this.$router.push({ name: getLandingRoute(roleId) });
          }
        } catch {
          this.$router.push({ name: getLandingRoute(roleId) });
        }
      } else if (roleId == 0 || roleId == 1) {
        // เดิมคือ /dashboard ซึ่งถูกปิดตาม menuClosure config
        this.$router.push({ name: getLandingRoute(roleId) });
      } else if (roleId == 2) {
        // เดิมคือ /VectorManagement ซึ่งถูกปิดตาม menuClosure config เช่นกัน
        this.$router.push({ name: getLandingRoute(roleId) });
      }
       else if (roleId == 6) {
        this.$router.push({ name: getLandingRoute(roleId) });
      }
    } else {
      Object.keys(Cookies.get()).forEach(function (cookieName) {
        if (cookieName != "rememberMe") {
          Cookies.remove(cookieName);
        }
      });
    }
    const rememberMeCookie = Cookies.get("rememberMe");
    if (rememberMeCookie) {
      let key = CryptoJS.enc.Hex.parse(import.meta.env.VITE_APP_JSKey);
      let decryptedData = this.decryptData(rememberMeCookie, key);
      const userData = JSON.parse(decryptedData);
      this.input.companyCode = userData.companyCode;
      this.input.username = userData.username;
      this.input.password = userData.password;
      this.companyName = userData.companyName;
      this.fullname = userData.fullname;
      this.hasCredential = true;
      this.switchToLogin = false;
      this.rememberMe = true;
      // const userData = JSON.parse(rememberMeCookie);
      // this.input.username = userData.username;
      // this.input.password = userData.password;
      // this.rememberMe = true;
    }
    this.CheckStatusSSO();
    // let login_username = this.readCookie("username");
    // let login_password = this.readCookie("password");
    // this.remember = this.readCookie("rememberme");
    // if (this.remember == "true") {
    //   this.expiryDate = this.readCookie("expiredate");
    //   let today = new Date();
    //   if (today >= this.expiryDate) {
    //     document.cookie = "username=" + ";expires=" + self.expiryDate;
    //     document.cookie = "password=" + ";expires=" + self.expiryDate;
    //     document.cookie = "rememberme=" + ";expires=" + self.expiryDate;
    //   } else {
    //     if (login_username != null && login_password != null) {
    //       this.input.username = this.cryptoMethods("decrypt", login_username);
    //       this.input.password = this.cryptoMethods("decrypt", login_password);
    //       this.login();
    //     }
    //   }
    // } else {
    //   this.expiryDate = new Date();
    //   this.expiryDate.setMonth(this.expiryDate.getMonth() + 1);
    //   document.cookie = "expiredate=" + this.expiryDate;
    // }
  },
  computed: {
    loginLogo() {
      return this.LoginLogo;
    },
    isMobile() {
      return !this.display.smAndUp.value;
    },
  },
  watch: {
    loginLogo(newValue) {
      this.images.logo = `${newValue}`;
    },
  },
  methods: {
    SwitchToLogin() {
      this.input.companyCode = "";
      this.input.username = "";
      this.input.password = "";
      this.hasCredential = false;
      this.switchToLogin = true;
    },
    async CheckStatusSSO() {
      let self = this;
      var tempRequest = {
        key: "SSO",
      };
      self.$call.CheckStatusSSO(
        tempRequest,
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            console.log("SSO Status:", dataResponse.data.microsoft);
            self.SSOAuthentikFlag = dataResponse.data.authentik;
            self.SSOMicrosoftFlag = dataResponse.data.microsoft;
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },

    async loginMicrosoft() {
      if (this.ProductAdminFlag && this.companyCodeInputCheck()) return;
      let self = this;
      self.clearMessage();
      Cookies.remove("userId");
      Cookies.remove("rememberMe");

      window.open(
        `${import.meta.env.VITE_APP_API}api/v0/SSO/SignIn?companyCode=${
          this.input.companyCode
        }`,
        "Popup",
        "width=850,height=750"
      );

      window.addEventListener("message", async function (event) {
        try {
          const data = event.data;
          let blocker = false;
          if (blocker) {
            console.log("Session Storage:", data);
            console.log("Cookies:", data.cookies);
          }

          window.location.reload(true);
        } catch (error) {
          return;
        }
      });
    },

    async loginAuthentik() {
      if (this.ProductAdminFlag && this.companyCodeInputCheck()) return;
      let self = this;
      self.clearMessage();

      Cookies.remove("userId");
      Cookies.remove("rememberMe");

      window.open(
        `${
          import.meta.env.VITE_APP_API
        }api/v0/SSO/SignInAuthentik?companyCode=${this.input.companyCode}`,
        "Popup",
        "width=850,height=750"
      );

      window.addEventListener("message", async function (event) {
        try {
          const data = event.data;
          let blocker = false;
          if (blocker) {
            console.log("Session Storage:", data);
            console.log("Cookies:", data.cookies);
          }

          window.location.reload(true);
        } catch (error) {
          return;
        }
      });
    },

    companyCodeInputCheck() {
      if (!this.input.companyCode) {
        this.companyCodeChecker = true;
        this.erroralert = true;
        this.errorMessage = "Please enter your company code.";
        return true;
      }
      return false;
    },

    // async loginLine() {
    //   let self = this;
    //   self.clearMessage();

    //       var myWindow = window.open(`${import.meta.env.VITE_APP_API}api/v0/SSO/SignInLine`, "Popup", "width=850,height=750");

    //   Cookies.remove('userId');
    //   var stopLoop = false;

    //   do {
    //     console.log('Wait for 5 seconds!');
    //     // if(Cookies.get('userId') != undefined)
    //     if(myWindow.closed == true)
    //     {
    //       stopLoop = true;
    //       window.location.reload(true);
    //     }
    //     await new Promise((resolve) => setTimeout(resolve, 5000));
    //   } while (stopLoop == false);
    // },

    forgot() {
      try {
        let self = this;
        self.dialog = true;
        self.loading = true;
        self.$call.ForgetPassword(
          self.Email,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.$swal.fire({
                icon: "success",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              self.loading = false;
              self.Email = "";
              self.dialog = false;
              self.forgotpassword = false;
            }
            self.dialog = false;
            self.loading = false;
          },
          (errorResource) => {
            self.erroralert = true;
            self.errorMessage = errorResource;
            self.loading = false;
          }
        );
      } catch (error) {
        this.LogTrace(error, "forgotPassword");
      }
    },
    login: function () {
      if (this.ProductAdminFlag && this.companyCodeInputCheck()) return;
      let self = this;

      self.clearMessage();
      self.loading = true;
      let companyCode = self.input.companyCode?.toLowerCase();
      let userName = self.input.username?.toLowerCase();
      let password = self.input.password;
      // let routeTest = "dashboard";
      // self.$router.push(`/${routeTest}`);
      self.$call.Login(
        {
          CompanyCode: companyCode,
          UserName: userName,
          Password: password,
        },
        (dataResponse) => {
          if (dataResponse.status == 0) {
            // self.$router.push(`/${routeTest}`);
            // localStorage.setItem("Version", dataResponse.data.version);
            // sessionStorage.setItem("Version", dataResponse.data.version);
            if (self.rememberMe) {
              let key = CryptoJS.enc.Hex.parse(import.meta.env.VITE_APP_JSKey);

              let data = JSON.stringify({
                companyName: dataResponse.data.companyName,
                fullname: dataResponse.data.fullName,
                companyCode: companyCode,
                username: userName,
                password: password,
              });

              let encryptedData = self.encryptData(data, key);
              Cookies.set("rememberMe", encryptedData, { expires: 365 });
              window.location.reload(true);
              // // บันทึก username และ password ในรูปแบบของคุฝฝี้
              // Cookies.set(
              //   'rememberMe',
              //   JSON.stringify({
              //     username: userName,
              //     password: password,
              //   }),
              //   { expires: 365 }
              // );
            } else {
              // ลบคุฝฝี้
              Cookies.remove("rememberMe");
              window.location.reload(true);
            }
          }
          self.dialog = false;
          self.loading = false;
        },
        (errorResource) => {
          if (self.hasCredential) self.errorRememberAlert = true;
          else self.erroralert = true;

          self.errorMessage = errorResource;
          self.errorMessage = "The User was not found.";
          self.loading = false;
        }
      );
    },
    clearMessage: function () {
      this.erroralert = false;
      this.successalert = false;
      this.errorMessage = "";
      this.successMessage = "";
    },
    readCookie(name) {
      let nameEQ = name + "=";
      let ca = document.cookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    cryptoMethods(type, value) {
      let self = this;
      if (value != null || value != "" || value != undefined) {
        if (type == "encrypt") {
          const encryptedText = this.CryptoJS.AES.encrypt(
            value,
            self.secretKey
          ).toString();
          return encryptedText;
        } else {
          const decryptedText = this.CryptoJS.AES.decrypt(
            value,
            self.secretKey
          ).toString(this.CryptoJS.enc.Utf8);
          return decryptedText;
        }
      }
    },
    encryptData(data, key) {
      let encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), key, {
        keySize: 256 / 32,
        iv: key,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return encryptedData.toString();
    },
    decryptData(data, key) {
      let decryptedData = CryptoJS.AES.decrypt(data, key, {
        keySize: 256 / 32,
        iv: key,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return JSON.parse(decryptedData.toString(CryptoJS.enc.Utf8));
    },
  },
};
</script>
<style scoped>
.forgotPassword {
  margin-top: 1.3rem;
}

.forgot {
  width: 10rem;
}

.login {
  width: 195px !important;
  border-radius: 60.026px !important;
  background: #ff4768 !important;
  color: #fff;
  box-shadow: 0px 36.44445px 42.87582px -8.57516px rgba(189, 189, 189, 0.14) !important;
}

.form {
  min-width: 50%;
}

.img-intersection {
  width: 100%;
  height: 100%;
  max-width: 100%;
}

.login-scroll-container {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch; /* สำหรับ iOS */
}

.login-form-container {
  position: relative;
  min-height: 100%;
  padding-bottom: 20px;
}

/* แก้ไข img-intersection2 ไม่ให้มีความสูงตายตัวเกินไป */
.img-intersection2 {
  width: 100%;
  height: auto;
  min-height: 80vh;
  max-width: 100%;
}

/* เพิ่มสำหรับ Firefox */
@-moz-document url-prefix() {
  .login-scroll-container {
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.3) transparent;
  }
}

/* Custom scrollbar สำหรับ webkit browsers (Chrome, Safari) */
.login-scroll-container::-webkit-scrollbar {
  width: 6px;
}

.login-scroll-container::-webkit-scrollbar-track {
  background: transparent;
}

.login-scroll-container::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 6px;
}

::v-deep .v-input__control .v-input__slot .v-text-field__slot input {
  font-size: 16px !important;
}

.form-group {
  margin-bottom: 15px;
  text-align: left;
}

.form-group label {
  display: block;
  font-size: 14px;
  color: #666;
}

.form-group input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
}

.form-group input:focus {
  border-color: #007bff;
  outline: none;
}

.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.user-image {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 8px 10px 12px rgba(0, 0, 0, 0.18);
}

.user-image img {
  width: 100%;
  height: auto;
}

.changeAccount {
  position: absolute;
  bottom: 10px;
  font-size: 18px;
  margin-top: 10px;
  text-decoration: none;
  color: #007bff;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.bg-image-container {
  position: relative;
  height: 100vh;
  overflow: hidden;
}

.full-height-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media screen and (max-width:900px) {
  /* .bg-image-container {
    display: none;
  } */
}
</style>
